import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { AppRoutes } from "src/app/shared/endpoints.enum";
import { AuthGuardService } from "src/app/services/auth-guard.service";

/* Kwikspace **/
import { DashboardComponent } from "./kwikspace/dashboard/dashboard.component";
import { QuotesComponent } from "./kwikspace/quotes/quotes.component";
import { CustomersComponent } from "./kwikspace/customers/customers.component";
import { RentalsComponent } from "./kwikspace/rentals/rentals.component";
import { ProductsComponent } from "./kwikspace/products/products.component";
import { TransportComponent } from "./kwikspace/transport/transport.component";
import { ReportsComponent } from "./kwikspace/reports/reports.component";

import { ViewQuoteComponent } from "./kwikspace/quotes/view-quote/view-quote.component";
import { NewRentalQuoteComponent } from "./kwikspace/quotes/new-rental-quote/new-rental-quote.component";
import { EditRentalQuoteComponent } from "./kwikspace/quotes/edit-rental-quote/edit-rental-quote.component";
import { NewPurchseQuoteComponent } from "./kwikspace/quotes/new-purchase-quote/new-purchase-quote.component";
import { EditPurchaseQuoteComponent } from "./kwikspace/quotes/edit-purchase-quote/edit-purchase-quote.component";

import { ViewCustomerComponent } from "./kwikspace/customers/view-customer/view-customer.component";
import { EditCustomerComponent } from "./kwikspace/customers/edit-customer/edit-customer.component";
import { NewCustomerComponent } from "./kwikspace/customers/new-customer/new-customer.component";

const routes: Routes = [
  {
    path: "pwa",
    component: DashboardComponent,
    data: { title: "Kwikspace" },
    children: [
      { path: AppRoutes.QUOTE_LIST, component: QuotesComponent },
      { path: AppRoutes.CUSTOMER_LIST, component: CustomersComponent },
      { path: AppRoutes.CUSTOMER_DETAILS, component: EditCustomerComponent },
      { path: AppRoutes.RENTAL_PRICING_LIST, component: RentalsComponent },
      { path: AppRoutes.PRODUCT_LIST, component: ProductsComponent },
      { path: AppRoutes.TRANSPORT_CHARGE_LIST, component: TransportComponent },
      { path: AppRoutes.REPORT, component: ReportsComponent },
      { path: AppRoutes.VIEW_QUOTE, component: ViewQuoteComponent },
      { path: AppRoutes.NEW_RENTAL_QUOTE, component: NewRentalQuoteComponent },
      {
        path: AppRoutes.EDIT_RENTAL_QUOTE,
        component: EditRentalQuoteComponent,
      },
      {
        path: AppRoutes.EDIT_PURCHASE_QUOTE,
        component: EditPurchaseQuoteComponent,
      },
      {
        path: AppRoutes.NEW_PURCHASE_QUOTE,
        component: NewPurchseQuoteComponent,
      },
      { path: AppRoutes.VIEW_CUSTOMER, component: ViewCustomerComponent },
      { path: AppRoutes.NEW_CUSTOMER, component: NewCustomerComponent },
      { path: "", redirectTo: AppRoutes.DASHBOARD, pathMatch: "full" },
    ],
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class PwaRoutingModule {}
